// Помилки submitForeignSupplierBid бекенд (commercial-services: ForeignSupplierServices,
// BidSubmitServiceBase, BidSubmitValidationService) віддає кодами без перекладу, а гейтвей
// прокидає їх як є — мапимо в Tenders.ForeignBidErrors.*
const KEY = 'Tenders.ForeignBidErrors'

// Частина помилок приходить не кодом, а готовою англійською фразою
const LITERAL_MESSAGES = {
  'Submission of a bid for all items is mandatory': 'mandatoryFullBid',
  'No tariff configured for the requested tender/bidding type.': 'noTariff',
}
const BID_PRICE_LIMIT = /^Bid price limit in \d+ lots \[([\d\s]*)\]$/

export default {
  methods: {
    $_foreignBidErrorMessage(error, lots = []) {
      // Помилки створення зовнішнього учасника (FOREIGN_SUPPLIER_ERRROR_*) приходять
      // GraphQL-помилкою з кодом у extensions.code, message при цьому порожній
      if (error?.graphQLErrors?.length) {
        const { message, extensions } = error.graphQLErrors[0]
        return this.foreignBidTranslate(extensions?.code) || message || this.$t('Errors.STHWrong')
      }
      const messages = [
        this.foreignBidErrorText(error?.message, error?.options, lots),
        ...(error?.lotMessages || []).map(lotMessage => this.foreignBidLotErrorText(lotMessage, lots)),
      ].filter(Boolean)
      return messages.length ? messages.join('; ') : this.$t('Errors.STHWrong')
    },
    foreignBidErrorText(message, options, lots = []) {
      if (!message || typeof message !== 'string') {
        return ''
      }
      const priceLimit = message.match(BID_PRICE_LIMIT)
      if (priceLimit) {
        const lotTitles = priceLimit[1].trim().split(/\s+/).filter(Boolean).map(lotId => this.foreignBidLotTitle(lotId, lots))
        return this.$t(`${KEY}.bidPriceLimit`, { lots: lotTitles.join(', ') })
      }
      return this.foreignBidTranslate(LITERAL_MESSAGES[message] || message, options) || message
    },
    // Переклад коду або '' якщо коду немає в словнику
    foreignBidTranslate(code, options) {
      const key = `${KEY}.${code}`
      if (typeof code === 'string' && /^\w+$/.test(code) && this.$te(key)) {
        return this.$t(key, this.foreignBidErrorOptions(options))
      }
      return ''
    },
    foreignBidLotErrorText(lotMessage, lots = []) {
      const text = this.foreignBidErrorText(lotMessage?.message, lotMessage?.options, lots)
      // lotId = 0 — помилка тендерного (не лотового) критерію
      if (!text || !lotMessage.lotId) {
        return text
      }
      return this.$t(`${KEY}.lotPrefix`, { lot: this.foreignBidLotTitle(lotMessage.lotId, lots), message: text })
    },
    foreignBidLotTitle(lotId, lots = []) {
      const lot = lots?.find(item => item.lotId == lotId)
      return lot?.title || lotId
    },
    // Бек для min/maxValueServerError кладе ключ "amount " з пробілом у кінці
    foreignBidErrorOptions(options) {
      if (!options || typeof options !== 'object') {
        return {}
      }
      return Object.keys(options).reduce((acc, key) => {
        acc[key.trim()] = options[key]
        return acc
      }, {})
    },
  },
}
